import cn from 'classnames';
import { useTheme } from 'styled-components';

import { IConDefaultType } from '..';

export enum FooterCircleIconVariant {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  TWITTER = 'twitter',
  YOUTUBE = 'youtube',
  KAKAO_TALK = 'kakao_talk',
  DISCORD = 'discord',
}

export interface IFooterCircleIconProps extends IConDefaultType {
  variant?: FooterCircleIconVariant;
}

function FooterCircleIcon({
  color,
  className,
  size = 28,
  rotate,
  flip,
  variant = FooterCircleIconVariant.FACEBOOK,
}: IFooterCircleIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === FooterCircleIconVariant.FACEBOOK && (
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="facebook">
            <circle id="Oval" cx="15" cy="15" r="14" stroke={color || '#E3E5E8'} />
            <path
              id="Path"
              d="M13.4506 21.7693V15.2752H11.2666V12.7459H13.4506V10.8792C13.4506 8.71387 14.7741 7.5332 16.707 7.5332C17.6319 7.5332 18.4271 7.6032 18.6586 7.63307V9.8964L17.3183 9.89734C16.2683 9.89734 16.0639 10.3967 16.0639 11.1293V12.7449H18.5709L18.2442 15.2752H16.0649V21.7693H13.4515H13.4506Z"
              fill="#8A8A8A"
            />
          </g>
        </svg>
      )}
      {variant === FooterCircleIconVariant.INSTAGRAM && (
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="instagram">
            <circle id="Oval" cx="15" cy="15" r="14" stroke={color || '#E3E5E8'} />
            <path
              id="Shape"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.7625 7.5332C20.2779 7.5332 22.3172 9.57254 22.3172 12.0888V17.7625C22.3172 20.2779 20.2779 22.3172 17.7625 22.3172H12.0879C9.57254 22.3172 7.5332 20.2779 7.5332 17.7625V12.0879C7.5332 9.57254 9.57254 7.5332 12.0879 7.5332H17.7625ZM17.2175 8.95187H12.6329C10.6001 8.95187 8.95187 10.6001 8.95187 12.6329V17.2175C8.95187 19.2512 10.6001 20.8985 12.6329 20.8985H17.2175C19.2493 20.8985 20.8985 19.2512 20.8985 17.2175V12.6329C20.8985 10.6001 19.2493 8.95187 17.2175 8.95187ZM18.6212 15.1679C18.6212 13.1267 16.9664 11.4719 14.9252 11.4719C12.884 11.4719 11.2292 13.1267 11.2292 15.1679C11.2292 17.2091 12.884 18.8639 14.9252 18.8639C16.9664 18.8639 18.6212 17.2091 18.6212 15.1679ZM14.9252 12.9447C13.6969 12.9447 12.7011 13.9396 12.7011 15.1688C12.7011 16.3961 13.6969 17.392 14.9252 17.392C16.1535 17.392 17.1484 16.3961 17.1484 15.1688C17.1484 13.9396 16.1535 12.9447 14.9252 12.9447ZM19.2372 11.274C19.2372 10.7635 18.8228 10.35 18.3132 10.35C17.8027 10.35 17.3892 10.7635 17.3892 11.274C17.3892 11.7836 17.8027 12.198 18.3132 12.198C18.8228 12.198 19.2372 11.7836 19.2372 11.274Z"
              fill="#8A8A8A"
            />
          </g>
        </svg>
      )}
      {variant === FooterCircleIconVariant.TWITTER && (
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="twitter">
            <circle id="Oval" cx="15" cy="15" r="14" stroke={theme.color.line.line_1} />
            <path
              id="Vector"
              d="M16.1415 14.0811L20.6088 9H19.5502L15.6713 13.4119L12.5733 9H9L13.6849 15.6716L9 21H10.0587L14.155 16.3409L17.4267 21H21L16.1414 14.0811H16.1417H16.1415ZM14.6916 15.7303L14.2169 15.066L10.4401 9.77976H12.0661L15.114 14.0459L15.5887 14.7102L19.5507 20.2556H17.9247L14.6917 15.7305V15.7302L14.6916 15.7303Z"
              fill={theme.color.text.TXT_1}
            />
            <path id="Rectangle 4883" d="M10 9.5H12.5L20 20.5H17.5L10 9.5Z" fill={theme.color.text.TXT_1} />
          </g>
        </svg>
      )}
      {variant === FooterCircleIconVariant.YOUTUBE && (
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="youtube">
            <circle id="Oval" cx="15" cy="15" r="14" stroke={color || '#E3E5E8'} />
            <path id="Path" d="M12 20L20 15L12 10V20Z" fill="#8A8A8A" />
          </g>
        </svg>
      )}
      {variant === FooterCircleIconVariant.KAKAO_TALK && (
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="14" stroke={theme.color.line.line_1} />
          <path
            d="M15 10C11.6865 10 9 12.1054 9 14.7046C9 16.3743 10.1125 17.8399 11.784 18.6762L11.2185 20.7712C11.2007 20.8241 11.2095 20.8823 11.2423 20.9276C11.2751 20.9729 11.3278 20.9999 11.384 21C11.4224 20.9989 11.4594 20.9851 11.489 20.9608L13.919 19.3304C14.2725 19.3805 14.6325 19.4093 15 19.4093C18.313 19.4093 21 17.3034 21 14.7046C21 12.1054 18.313 10 15 10Z"
            fill={theme.color.text.TXT_1}
          />
        </svg>
      )}
      {variant === FooterCircleIconVariant.DISCORD && (
        <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke={theme.color.line.line_1} />
          <path
            d="M19.5535 9.00498C18.5023 8.52873 17.3925 8.19086 16.2526 8C16.0966 8.27595 15.9555 8.55987 15.8298 8.85056C14.6155 8.66949 13.3807 8.66949 12.1664 8.85056C12.0406 8.5599 11.8995 8.27598 11.7436 8C10.6029 8.19247 9.4924 8.53114 8.44013 9.00747C6.3511 12.066 5.78479 15.0486 6.06794 17.9888C7.29133 18.8833 8.66066 19.5635 10.1164 20C10.4442 19.5637 10.7342 19.1009 10.9835 18.6164C10.5101 18.4415 10.0532 18.2256 9.61804 17.9714C9.73256 17.8892 9.84456 17.8045 9.95279 17.7223C11.2189 18.3115 12.6008 18.617 14 18.617C15.3991 18.617 16.781 18.3115 18.0472 17.7223C18.1566 17.8107 18.2686 17.8954 18.3819 17.9714C17.9459 18.226 17.4882 18.4423 17.014 18.6177C17.2629 19.1019 17.553 19.5644 17.881 20C19.338 19.5653 20.7084 18.8853 21.932 17.99C22.2642 14.5803 21.3644 11.6252 19.5535 9.00498ZM11.3421 16.1806C10.5531 16.1806 9.90119 15.472 9.90119 14.6002C9.90119 13.7285 10.5304 13.0137 11.3396 13.0137C12.1488 13.0137 12.7956 13.7285 12.7818 14.6002C12.7679 15.472 12.1463 16.1806 11.3421 16.1806ZM16.6578 16.1806C15.8675 16.1806 15.2182 15.472 15.2182 14.6002C15.2182 13.7285 15.8474 13.0137 16.6578 13.0137C17.4683 13.0137 18.1101 13.7285 18.0962 14.6002C18.0824 15.472 17.462 16.1806 16.6578 16.1806Z"
            fill={theme.color.text.TXT_1}
          />
        </svg>
      )}
    </i>
  );
}

export default FooterCircleIcon;
